// Author YuJiaBei
// Date 2020-08-07 15:55:23

class EmLcAccInstAccTypeIat {
constructor({
        id = null,
        iatName = '',
        iatDescription = ''}
= {}) {
    this.id = id;
    this.iatName = iatName;
    this.iatDescription = iatDescription;
}
}

function newEntity() {
return new EmLcAccInstAccTypeIat();
}

function gridFields() {
return Object.freeze([
        {
        key: 'iatName',
        label: 'label.em.lifecycle.emLcAccInstAccTypeIat.grid.iatName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'iatDescription',
        label: 'label.em.lifecycle.emLcAccInstAccTypeIat.grid.iatDescription',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
]);
}

const filter = {
    iatNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'iatNameFilter',
        label: 'label.em.lifecycle.emLcAccInstAccTypeIat.filter.iatName',
        disabled: false,
        form: {
        type: 'input'
                }
        }
];

const entityFormConfigs = [
        {
        key: 'iatName',
        label: 'label.em.lifecycle.emLcAccInstAccTypeIat.entity.iatName',
        sortable: true,
        disabled: false,
        form: {
        type: 'input'
            ,required: true
                }
        },
        {
        key: 'iatDescription',
        label: 'label.em.lifecycle.emLcAccInstAccTypeIat.entity.iatDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {EmLcAccInstAccTypeIat, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs , filterConfigs}
